import React, { FC } from 'react';
import { CardContent } from '@material-ui/core';
import { unionBy } from 'lodash';

import { useContent } from 'hooks';
import { UserAvatar } from 'components';
import { AvatarGroup } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  avatar: {
    border: `1px ${theme.palette.common.white} solid`,
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));

const Engagements: FC = () => {
  const classes = useStyles();

  const { reacted_by, shared_by, commented_by } = useContent();
  const uniqueUsers = unionBy(reacted_by, shared_by, commented_by, 'id');

  if (!uniqueUsers.length) {
    return null;
  }

  return (
    <CardContent>
      <AvatarGroup max={20} classes={{ avatar: classes.avatar }}>
        {uniqueUsers.map(user => (
          <UserAvatar user={user} key={user.id} />
        ))}
      </AvatarGroup>
    </CardContent>
  );
};

export default Engagements;
